import { Injectable, NgZone } from '@angular/core';
import { ToastSummary, ToastType } from '@d-constants';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

interface ToastModel {
  type: ToastType;
  message: string;
  messageParams?: any;
  life?: number;
  summary?: ToastSummary | string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(
    private messageService: MessageService,
    private translateService: TranslateService,
  ) {}

  addSingle(toastConfig: ToastModel) {
    this.messageService.add({
      summary: toastConfig.summary ?? this.getDefaultSummary(toastConfig.type),
      severity: toastConfig.type,
      detail:
        typeof toastConfig.message === 'string'
          ? this.translateService.instant(
              toastConfig.message,
              toastConfig.messageParams,
            ) || toastConfig.message
          : '',
      key: 'tr',
      life: toastConfig.life || 5000,
    });
  }

  addMultiple(toastConfig: ToastModel[]) {
    this.messageService.addAll(
      toastConfig.map((i) => {
        return {
          severity: i.type,
          detail: this.translateService.instant(i.message),
          key: 'tr',
          life: i.life || 5000,
        };
      }),
    );
  }

  clear() {
    this.messageService.clear();
  }

  private getDefaultSummary(type: string) {
    const key = Object.keys(ToastSummary)[
      Object.values(ToastType).indexOf(type as ToastType)
    ] as keyof typeof ToastSummary;
    return ToastSummary[key];
  }
}
